
<app-header></app-header>
<section class="wrapper">
    <app-sidebar></app-sidebar>
    <router-outlet></router-outlet>
    <footer></footer>
</section>